import { render, staticRenderFns } from "./qingsuModel.vue?vue&type=template&id=7bbd0a8e&scoped=true&"
import script from "./qingsuModel.vue?vue&type=script&lang=js&"
export * from "./qingsuModel.vue?vue&type=script&lang=js&"
import style0 from "./qingsuModel.vue?vue&type=style&index=0&id=7bbd0a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd0a8e",
  null
  
)

export default component.exports